module.exports = __webpack_public_path__ + "media/images/icon__profile@3x-0683305e00195ced02219a964a386d62.png";